@if (tradeService.asset$ | async; as asset) {
  @if (asset.instrumentType === 'KRYPTO') {
    <div class="col-12 zero-text p-small-reg text-center mt-3">{{ 'trade.create.crypto-hint' | transloco }}</div>
  }
}
